const zh = {
	'注册/登录': '注册/登录',
	'点击右上角的按钮,选择在浏览器中打开': '点击右上角的按钮,选择在浏览器中打开',
	'学习最地道的中文':'学习最地道的中文',
	'VIP套餐':'VIP套餐',
	'{N}个月':'{num}个月',
	'节省{%}':'节省{percent}',
	'立即购买':'立即购买',
	'点击购买/续费即表示您已阅读并同意《自动续费服务规则》、《服务使用协议》、《用户隐私协议》':'点击购买/续费即表示您已阅读并同意<span onclick="protocol()">《服务使用协议》</span>、<span onclick="privacy()">《用户隐私协议》</span>',
	'畅学600+超级进阶课程':'畅学600+超级进阶课程',
	'超20年资深教研团队倾心编写':'超20年资深教研团队倾心编写',
	'词汇':'词汇',
	'选取高频词汇，学以致用':'选取高频词汇，学以致用',
	'全方位训练听、说、读、写':'全方位训练听、说、读、写',
	'语法':'语法',
	'科学系统的语法知识体系':'科学系统的语法知识体系',
	'掌握语法结构，灵活运用':'掌握语法结构，灵活运用',
	'课文':'课文',
	'100+ 日常话题，沉浸式中文学习体验':'100+ 日常话题，沉浸式中文学习体验',
	'AI引擎智能打分，从此大胆开口说中文':'AI引擎智能打分，从此大胆开口说中文',
	'小测试':'小测试',
	'检验课程内容的学习情况':'检验课程内容的学习情况',
	'定位薄弱项，给出学习推荐':'定位薄弱项，给出学习推荐',
	'智能AI引擎为你保驾护航':'智能AI引擎为你保驾护航',
	'个性化学习推荐，由浅入深系统学习':'个性化学习推荐，由浅入深系统学习',
	'独家AI算法分析，科学安排复习':'独家AI算法分析，科学安排复习',
	'智能错题收集，帮你查漏补缺':'智能错题收集，帮你查漏补缺',
	'VIP专属特权':'VIP专属特权',
	'功能特权':'功能特权',
	'VIP':'VIP',
	'普通用户':'普通用户',
	'知识库':'知识库',
	'Flashcard':'Flashcard',
	'收藏':'收藏',
	'用户反馈':'用户反馈',
	'学习{N}天':'学习<span class="light">{day}</span>天',
	'初始水平':'初始水平',
	'目前水平':'目前水平',
	'需要帮助？':'需要帮助？',
	'选择支付方式':'选择支付方式',
	'微信':'微信',
	'支付宝':'支付宝',
	'立即支付':'立即支付',
	'购买成功':'购买成功',
	'体验': '体验',
	'支付失败': '支付失败',
	'确定支付完成了吗?':'确定支付完成了吗?',
	'我已支付完成':'我已支付完成',
	'重新支付':'重新支付',
	"确定退出登录？": "确定退出登录？",
    '确定': '确定',
	"取消": "取消",
    '支付失败': "支付失败",
	"没有账号，立即注册": "没有账号，立即注册",
	"请确认密码": "请确认密码",
	"请输入手机号": "请输入手机号",
	"请输入邮箱": "请输入邮箱",
	"请输入账号": "请输入账号",
	"手机号不能为空": "手机号不能为空",
	"手机注册": "手机注册",
	"已有账号，立即登录": "已有账号，立即登录",
	"邮箱不能为空": "邮箱不能为空",
	"邮箱格式不正确": "邮箱格式不正确",
	"邮箱注册": "邮箱注册",
	"登录/注册": "登录/注册",
	"密码长度不能小于6位": "密码长度不能小于6位",
	"请输入验证码": "请输入验证码",
	"请输入密码": "请输入密码",
	"已有账号？立即登录": "已有账号？立即登录",
	"还没有账号？立即注册": "还没有账号？立即注册",
	"请输入您的账号": "请输入您的账号",
	"注册": "注册",
	"国家": "国家",
	"获取验证码": "获取验证码",
	"登录": "登录",
	"忘记密码": "忘记密码",
	"确认密码": "确认密码",
	"提交": "提交",
	"请输入邮箱":"请输入邮箱",
	"请输入密码":"请输入密码",
	"确认密码":"确认密码",
	"忘记密码":"忘记密码",
	"请输入已有账号":"请输入已有账号",
	"填写验证码":"填写验证码",
	"获取验证码":"获取验证码",
	"提交":"提交",
	"登录":"登录",
	"所在国家":"所在国家",
	"请输入手机号":"请输入手机号",
	"使用邮箱":"使用邮箱",
	"使用手机":"使用手机",
	"注册":"注册",
	"用户隐私与使用协议":"用户隐私与使用协议",
	"打开APP学习":"打开APP学习",
}
export default zh;